import React from "react";
import { Route, Switch } from "react-router";
import { Main as MainLayout } from "components/Layout";
import Produit from "app/Produit";
import Stats from "app/Stats";
import ExportDiagram from "app/Stats/Export";
import Import from "app/Import";

const FrontModule: React.FC = () => {
    return (
        <MainLayout>
            <Switch>
                <Route path="/import" render={() => <Import />} />
                <Route path="/stats/export" render={() => <ExportDiagram />} />
                <Route path="/stats" render={() => <Stats />} />
                <Route path="" render={() => <Produit />} />
            </Switch>
        </MainLayout>
    );
};

const NoAuthModule: React.FC = () => {
    return (
        <Switch>
            <Route path="" render={() => <FrontModule />} />
        </Switch>
    );
};

const ModuleRouter: React.FC = () => {
    return <NoAuthModule />;
};

export default ModuleRouter;
